<template>
    <ui-crud title="Application for payments" subtitle="All Application for Payments for this package"
             ref="crud"
             :fetch="fetch"
             :pipe-with="pipeItems"
             :group-by="groupByStatus">
        <template #new-button>
            <div class="flex items-center">
                <h1 class="text-lg font-medium text-gray-900">Application for Payments</h1>
                <ui-button-new small class="ml-auto hidden sm:inline-flex" icon="fas fa-plus"
                               @click.prevent="createNew()">New
                </ui-button-new>
            </div>
            <p class="mt-1 text-sm text-gray-600">All Application for Payments for this package</p>
            <ui-button-new class="sm:hidden mt-4" icon="fas fa-plus"
                           @click.prevent="createNew()">New
            </ui-button-new>
        </template>

        <!-- Filters. -->
        <template #filters>
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>
        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`AFP #${item.reference}`"
                :metadataSubtitle="`${item.formatted_date}`"
                :subtitle="`${item.createdBy}`"
                :metadata="''"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem, setEditMode, selectItem }">
            <div class="flex space-x-8 pt-4 px-4 m-4 justify-center items-center">
                <div
                    class="border border-grey-200 rounded-l bg-gray-50 w-full h-full p-4 justify-center items-center text-center text-gray-500">
                    <-- Please select an existing Application for Payment to view/edit or click new to create a new one.
                </div>
            </div>
        </template>

        <template #edit="{ selectedItem, setEditMode, removeItem, addItem, selectItem }">
            <application-for-payment-show :package-reference="packageReference" :package-name="packageName"
                                          :select-item="selectItem" :selected-item="selectedItem"
                                          :readonly="false"></application-for-payment-show>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem, addItem, selectItem }">
            <application-for-payment-show :package-reference="packageReference" :package-name="packageName"
                                  :select-item="selectItem" :selected-item="selectedItem"
                                  :readonly="true"></application-for-payment-show>
        </template>
    </ui-crud>
</template>

<script>

import {ApplicationForPayment} from "@models";
import ApplicationForPaymentShow from "./ApplicationForPaymentShow.vue";
import ApplicationForPaymentCreate from "./ApplicationForPaymentCreate.vue";
import UiCrud from "../../ui/UiCrud.vue";
import {uuid} from "../../../utils";

export default {
    components: {UiCrud, ApplicationForPaymentShow, ApplicationForPaymentCreate},
    props: {
        packageReference: null,
        packageName: null,
        admin: Boolean,
    },
    computed: {},
    data() {
        return {
            search: '',
        }
    },
    methods: {
        async fetch() {
            return await ApplicationForPayment.list(this.packageReference)
        },
        async createNew() {
            let id = uuid();
            try {
                await ApplicationForPayment.create(this.packageReference, id)
                await this.$refs.crud.fetchItems();
                this.$nextTick(() => {
                    this.$refs.crud.selectItem(this.$refs.crud.items.find((i) => i.id === id), true);
                })
            } catch (error) {
//                console.log(error);
            }
        },

        pipeItems(items) {
            const query = this.search.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            if (query.length) {
                return items.filter((pr) => {
                    return (this.$refs.crud.selectedItem && (pr.id == this.$refs.crud.selectedItem.id)) || query.every((token) => {
                        return pr.tokens.includes(token);
                    })
                });
            }
            return items;
        },
        groupByStatus(item) {
            return item.status;
        },

    },
}
</script>
